import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'familyPlanLanding.invest.heading',
		defaultMessage: 'How it works',
		description: 'Heading for high level feature section',
	},
	headingAccept: {
		id: 'familyPlanLanding.invest.headingAccept',
		defaultMessage: 'Find your Calm, together',
		description: 'Heading for high level feature section',
	},
	item1Heading: {
		id: 'familyPlanLanding.invest.item1Heading',
		defaultMessage: 'Choose your family',
		description: 'Heading for stress stat',
	},
	item1Description: {
		id: 'familyPlanLanding.invest.item1Description',
		defaultMessage: 'Pick your six—from your besties to your Aunties.',
		description: 'Explanation for stress stat',
	},
	item2Heading: {
		id: 'familyPlanLanding.invest.item2Heading',
		defaultMessage: 'Enjoy cost savings',
		description: 'Heading for sleep stat',
	},
	item2Description: {
		id: 'familyPlanLanding.invest.item2Description',
		defaultMessage: 'Six accounts for one low price (that’s 77% in savings).',
		description: 'Explanation of sleep better stat',
	},
	item3Heading: {
		id: 'familyPlanLanding.invest.item3Heading',
		defaultMessage: 'Find more calm, together',
		description: 'Heading for happiness stat',
	},
	item3Description: {
		id: 'familyPlanLanding.invest.item3Description',
		defaultMessage: 'Start or continue your mindfulness journey with the people you love.',
		description: 'Explanation for feel happier stat',
	},
	item1HeadingAccept: {
		id: 'familyPlanLanding.invest.item1HeadingAccept',
		defaultMessage: 'For your chosen family',
		description: 'Heading for stress stat',
	},
	item1DescriptionAccept: {
		id: 'familyPlanLanding.invest.item1DescriptionAccept',
		defaultMessage: 'From your besties to your Aunties. You don’t need to live under 1 roof',
		description: 'Explanation for stress stat',
	},
	item2HeadingAccept: {
		id: 'familyPlanLanding.invest.item2HeadingAccept',
		defaultMessage: 'Enjoy cost savings',
		description: 'Heading for sleep stat',
	},
	item2DescriptionAccept: {
		id: 'familyPlanLanding.invest.item2DescriptionAccept',
		defaultMessage: '1 plan: 6x the Sleep Stories, 6x the meditation, 6x the Calm',
		description: 'Explanation of sleep better stat',
	},
	item3HeadingAccept: {
		id: 'familyPlanLanding.invest.item3HeadingAccept',
		defaultMessage: 'Build your support network',
		description: 'Heading for happiness stat',
	},
	item3DescriptionAccept: {
		id: 'familyPlanLanding.invest.item3DescriptionAccept',
		defaultMessage: 'Create community to support you in your mindfulness journey',
		description: 'Explanation for feel happier stat',
	},
});
